import { BaseService } from './base.service';

export interface SearchResult {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  // 'contact' = a SmartLev (GHL) CRM contact that is not yet a Tee Box member/lead
  type: 'member' | 'lead' | 'contact';
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface SearchResults {
  members: SearchResult[];
  leads: SearchResult[];
  contacts: SearchResult[];
}

export class SearchService extends BaseService {
  constructor() {
    super('/search');
  }

  async search(
    q: string,
    locationId?: string,
    includeCrmContacts = false,
    cohortAdd = false,
  ): Promise<SearchResults> {
    const params = new URLSearchParams({ q });
    if (locationId) params.set('locationId', locationId);
    if (includeCrmContacts) params.set('includeCrmContacts', 'true');
    if (cohortAdd) params.set('cohortAdd', 'true');
    const results = await this.get<{
      members: Omit<SearchResult, 'type'>[];
      leads: Omit<SearchResult, 'type'>[];
      contacts?: Omit<SearchResult, 'type'>[];
    }>(`?${params}`);
    return {
      members: results.members.map((m) => ({ ...m, type: 'member' as const })),
      leads: results.leads.map((l) => ({ ...l, type: 'lead' as const })),
      contacts: (results.contacts ?? []).map((c) => ({
        ...c,
        type: 'contact' as const,
      })),
    };
  }
}

export const searchService = new SearchService();
